// import React, { useEffect, useState } from "react";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import i18n from "i18next";
import { ProgressBar } from 'react-bootstrap'
import { useTranslation, initReactI18next } from "react-i18next";
import common_en from "../../translations/en/common.json"
import common_de from "../../translations/de/common.json"
import common_nl from "../../translations/nl/common.json"
import { useDispatch } from "react-redux";
import { loginStatus } from "../../actions/userActions";
import { InputWithErrors } from "../../components/Basic/Input/InputWithErrors";
import SelectWithErrors from "../../components/Basic/Select/SelectWithErrors";
import { Bars } from "react-loader-spinner";
import generateString from "../../customFunction/generateString";
import "./add.css"

i18n
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'en',                              // language to use
    resources: {
      en: {
        common: common_en
      },
      de: {
        common: common_de
      },
      nl: {
        common: common_nl
      }
    },
  });

const AddScenario = (async) => {
  const { t } = useTranslation('common')
  const [folders, setFolders] = useState([]);
  const [tags, setTags] = useState([]);
  const [ea5File, setEa5File] = useState();
  const [sourceFile, setSourceFile] = useState()
  const [metaFile, setMetaFile] = useState()
  const [eventFile, setEventFile] = useState()
  const [imageFile, setImageFile] = useState();
  const [progress, setProgress] = useState(0)
  const history = useHistory()
  const [errors, setErrors] = useState([])
  const [fileLength, setFileLength] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [timeStamps, setTimeStamps] = useState({ minutes: 0, second: 0 })
  const [startTime, setStartTime] = useState({ minutes: "", seconds: "" })
  const [endTime, setEndTime] = useState({ minutes: "", seconds: "" })
  const [warningMessage, setWarningMessage] = useState("")
  const [warningColor, setWarningColor] = useState("red")
  const [isServerError, setIsServerError] = useState(false)
  const [isSaved, setIsSaved] = useState(false)
  const [saveMessage, setSaveMessage] = useState("")
  const [isSaveDisabled, setIsSaveDisabled] = useState(false)
  const [duration, setDuration] = useState(null)
  const { folderID } = useParams()

  const userInfo = JSON.parse(localStorage.getItem('userInfo'))
  const token = userInfo !== null ? userInfo.token : null
  const uid = userInfo !== null ? userInfo.user_id : null;

  const dispatch = useDispatch()
  let parentFolder = []

  const configJson = {
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`
    },
  };

  const [form, setForm] = useState({
    name: "",
    folder_id: folderID,
    favorite: false,
    source: "saivavt",
    scenarioType: "match",
    startTime: "",
    endTime: "",
    description: "",
    tag: null,
    calibratorKind: "Scouting",
    trackerType: "Greedy_matcher",
    showDescription: false
  });

  const [dragActive, setDragActive] = useState(false);

  const composingRef = useRef(false);

  const onNameChange = (e) => {
    if (composingRef.current) return;
    const v = e.target.value ?? "";
    setForm((f) => ({ ...f, name: v }));
  };

  useEffect(() => {
    const getFolders = async () => {
      try {
        const folders = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/folder/user/${uid}`,
          configJson
        );

        folders.data.map(folder => {
          if (folder.parent_id === 0) {
            parentFolder.push(folder)
          }
        })

        folders.data.map(folder => {
          if (folder.parent_id !== 0) {
            parentFolder.map(parent => {
              if (parent.folder_id === folder.parent_id) {
                folder.name = `${parent.name}/${folder.name}`
                return folder
              }
            })
          } else {
            return folder
          }
        })

        setFolders(folders.data);
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(loginStatus())
        }
      }
    };
    getFolders();
  }, [tags]);

  const uploadFile = async (e) => {
    setWarningMessage('')
    if (e.target.files && e.target.files.length === 1) {
      if (e.target.name === "meta") {
        setMetaFile(e.target.files[0])
      } else if (e.target.name === "event") {
        setEventFile(e.target.files[0])
      } else {
        if (form.source === "saivavt") {
          getSaivaVTLength(e)
        } else if (form.source === "ea5") {
          getEa5Length(e)
        } else if (form.source === "metrica") {
          getMetricaLength(e)
        } else if (form.source === "sportec") {
          getSportectLength(e)
        }
        setSourceFile(e.target.files[0])
      }
    }
  }

  useEffect(() => {

  }, [duration])

  const getSportectLength = (e) => {
    e.preventDefault()
    const fileName = e.target.files[0].name
    const lengthFile = fileName.split(".")[0].split("_")[2].split("-")
    const frameLength = (Number(lengthFile[1]) - Number(lengthFile[0])) / 50
    console.log(frameLength)
    if (frameLength > 60) {
      setWarningMessage('Scenario should be no longer than 1 minute.')
    }
  }

  const getEa5Length = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    reader.onload = async (e) => {
      // const text = (e.target.result)
      // const isball = JSON.parse(text).sceneObjects.some(obj => {
      const text = e.target.result
      await new Promise((r) => setTimeout(r, 0))
      const data = JSON.parse(text)
      const isball = data.sceneObjects.some(obj => {

        return /\b\w*ball\w*\b/g.test(obj.type)
      })

      !isball ? setWarningMessage('Ball does not exist, please upload another scenario') : setWarningMessage('')

      // const fileLength = JSON.parse(text).sceneCount
      const fileLength = data.sceneCount
      setTimeStamps({ minutes: padTo2Digits(Math.floor(fileLength / 60)), second: padTo2Digits(fileLength % 60) })
    }
    reader.readAsText(e.target.files[0])
  }

  const getMetricaLength = (e) => {
    e.preventDefault()
    const reader = new FileReader()
    reader.onload = async (e) => {
      const text = (e.target.result)
      // const fileLength = JSON.parse(text).sceneCount
      // setTimeStamps({ minutes: padTo2Digits(Math.floor(fileLength / 60)), second: padTo2Digits(fileLength % 60) })
    }
    reader.readAsText(e.target.files[0])
  }

  const getSaivaVTLength = (e) => {
    // e.preventDefault()
    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(video.src);
      var duration = video.duration;
      setDuration(duration)
      setTimeStamps({ minutes: padTo2Digits(Math.floor(duration / 60)), second: padTo2Digits(Math.floor(duration % 60)) })
    }
    video.src = URL.createObjectURL(e.target.files[0]);
  }

  const uploadImage = async (e) => {
    if (e.target.files && e.target.files.length === 1) {
      setImageFile(e.target.files[0])
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    const sTime = (parseInt(startTime.minutes) * 60) + parseInt(startTime.seconds)
    const eTime = (parseInt(endTime.minutes) * 60) + parseInt(endTime.seconds)

    const formData = new FormData()

    formData.append('image', imageFile)
    if (sourceFile) {
      formData.append('file', sourceFile)
      formData.append('fileName', sourceFile.name)
    }
    formData.append('metaFile', metaFile)
    formData.append('eventFile', eventFile)
    formData.append('scenario_id', generateString(28).trim())
    formData.append('name', form.name)
    formData.append('folder_id', form.folder_id)
    formData.append('favorite', form.favorite)
    formData.append('calibrator', form.calibratorKind)
    formData.append('trackerType', form.trackerType)
    formData.append('server_id', 4)
    formData.append('source', form.source)
    formData.append('scenarioType', form.scenarioType)
    formData.append('startTime', sTime)
    formData.append('endTime', eTime)
    formData.append('description', form.description)
    formData.append('tags', tags.toString())

    try {
      setIsLoading(true)
      setIsSaveDisabled(true)

      const scenario = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        onUploadProgress: data => {
          setProgress(Math.round((100 * data.loaded) / data.total))
        }
      })

      if (form.source !== 'saivavt') {
        const saicaData = {
          name: scenario.data.name,
          fileName: sourceFile ? sourceFile.name : "",
          scenario_id: scenario.data.scenario_id,
          scenarioType: scenario.data.scenarioType,
          source: scenario.data.source
        }
        await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/scenarios/saica`, saicaData, configJson)
      }

      setIsLoading(false)
      setIsSaveDisabled(false)
      setIsSaved(true);
      setSaveMessage(`Scenario has been saved.`);
      window.scrollTo({ top: 0, behavior: "smooth" });

      setTimeout(() => {
        history.push({
          pathname: '/scenarios',
          state: { folderId: form.folder_id }
        })
      }, 1500)
    } catch (error) {
      setIsLoading(false)
      setErrors(error.response.data)
      if (error.response.status === 500) {
        setIsServerError(true)
      }
      if (error.response.status === 401) {
        dispatch(loginStatus())
      }
    }
  };

  const onChangeStartTime = async (e) => {
    let value = 0

    const regexPattern = /^[0-9]*$/;

    if (regexPattern.test(e.target.value)) {
      if (e.target.value > 60) {
        value = 60
      } else {
        value = e.target.value
      }
      setStartTime({ ...startTime, [e.target.name]: value })
    }
  }
  const onChange = async (e) => {
    setWarningMessage('')
    if (e.target.name === "favorite") {
      setForm({ ...form, favorite: !form.favorite });
      return
    }

    if (e.target.value === "saivavt" || e.target.value === 'metrica' || e.target.value === 'sportec') {
      setForm({ ...form, [e.target.name]: e.target.value, scenarioType: 'match' });
      return
    }

    if (e.target.name !== "scenarioType" && e.target.value === "ea5") {
      setForm({ ...form, [e.target.name]: e.target.value, scenarioType: '0' });
      return
    }
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const addTags = (e) => {
    e.persist();
    if (e.key === "Enter") {
      if (tags.indexOf(e.target.value) === -1) {
        (async () => {
          await setTags((arr) => [...arr, e.target.value]);
          e.target.value = null
        })()
      } else {
        e.target.value = null
      }
    }
  };

  const removeTag = (index) => {
    const arr = [...tags]
    arr.splice(index, 1)
    setTags(arr)
  }

  useEffect(() => {
    const sTime = (parseInt(startTime.minutes) * 60) + parseInt(startTime.seconds)
    const eTime = (parseInt(endTime.minutes) * 60) + parseInt(endTime.seconds)

    if (eTime < sTime) {
      setWarningMessage('Your duration is invalid')
      setWarningColor("red")
    }
    else if (eTime - sTime > 300) {
      setWarningMessage('Scenario length cannot more than 5 minutes')
      setWarningColor("red")
    } else if (eTime > sTime) {
      setWarningMessage('Your duration is valid')
      setWarningColor("green")
    }
  }, [startTime, endTime])

  const onChangeEndTime = async (e) => {
    let value = 0;

    const regexPattern = /^[0-9]*$/;

    if (regexPattern.test(e.target.value)) {
      if (e.target.value > 60) {
        value = 60
      } else {
        value = e.target.value
      }
      setEndTime({ ...endTime, [e.target.name]: value })
    }
  }

  const padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
  }

  const getLabelName = (source) => {
    if (source === "saivavt") {
      return "Video"
    } else if (source === "ea5") {
      return "Easy Animation"
    } else if (source === "metrica") {
      return "Metrica"
    } else if (source === "sportec") {
      return "Sportec"
    }
  }

  return (
    <div className="container-fluid loaded" style={{ display: "block" }}>
      {/* <div style={{ display: isLoading ? "block" : "none", position: "absolute", top: "29rem", left: "51.4rem", zIndex: 1, color: "#60a5fa" }}>
        <Bars
          height="80"
          width="80"
          color="#2563eb"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
        <p style={{ textAlign: "center", fontSize: "20px" }}>Processing....</p>
      </div> */}
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="/">{t('ADMIN_HOME')}</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/scenarios">Scenarios</Link>
                </li>
                <li className="breadcrumb-item active">{t('Add scenario')}</li>
              </ol>
            </div>
            <h4 className="page-title">{t('Add scenario')}</h4>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div
            className="alert alert-success"
            role="alert"
            style={{ display: isSaved ? "block" : "none" }}
          >
            {saveMessage || "Scenario saved successfully."}
            <button
              type="button"
              className="close"
              onClick={() => setIsSaved(false)}
              style={{ float: "right", border: "none", background: "transparent" }}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div style={{ display: isServerError ? "block" : "none" }} class="alert alert-danger" role="alert">
            {errors.message}
          </div>

          <form onSubmit={onSubmit} className="form-horizontal">

            {/* Step 1: Scenario Details */}
            <div className="step-container">
              <div className="step-header">
                <div className="step-number">1</div>
                <h3 className="step-title">{t('Scenario Details')}</h3>
              </div>

              <div className="form-group">
                <label className="font-weight-bold">{t('Scenario Name')} <span className="text-danger">*</span></label>
                <InputWithErrors
                  name="name"
                  value={form.name}
                  onChange={onNameChange}
                  onCompositionStart={() => (composingRef.current = true)}
                  onCompositionEnd={(e) => {
                    composingRef.current = false;
                    setForm((f) => ({ ...f, name: e.target.value ?? "" }));
                  }}
                  autoComplete="off"
                  errors={errors}
                  placeholder="e.g., Match vs Team B - First Half"
                  className="form-control form-control-lg"
                />
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>{t('Folder')}</label>
                    <SelectWithErrors
                      name="folder_id"
                      value={form.folder_id}
                      errors={errors}
                      data={folders}
                      keyPair={{ key: 'folder_id', val: 'name' }}
                      onChange={onChange}
                      intialSelect={{ key: 0, val: t('Rootfolder') }}
                      className="form-control"
                    />
                    <small className="form-text text-muted">Select where to save this scenario.</small>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <div
                  className="description-toggle"
                  onClick={() => setForm(f => ({ ...f, showDescription: !f.showDescription }))}
                >
                  <i className={`fa ${form.showDescription ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
                  {form.showDescription ? "Hide Description" : "Add Description (Optional)"}
                </div>

                {form.showDescription && (
                  <div className="mt-2">
                    <textarea
                      className="form-control"
                      rows="3"
                      name="description"
                      value={form.description}
                      onChange={onChange}
                      placeholder="Enter a brief description of the scenario..."
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Step 2: Media Source */}
            <div className="step-container">
              <div className="step-header">
                <div className="step-number">2</div>
                <h3 className="step-title">{t('File Source')}</h3>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="font-weight-bold">Source</label>
                    <SelectWithErrors
                      name="source"
                      value={form.source}
                      errors={errors}
                      data={
                        [
                          { "id": "saivavt", "name": "Video" },
                          { "id": "sportec", "name": "Sportec Position Data" }
                        ]
                      }
                      keyPair={{ key: "id", val: "name" }}
                      onChange={onChange}
                      className="form-control"
                      intialSelect={{ key: "0", val: "Select Source" }}
                    />
                  </div>
                </div>
              </div>

              {form.source != 0 && (
                <div className="mt-3">
                  <label className="font-weight-bold mb-2">{getLabelName(form.source)} Upload</label>

                  <div className={`hero-upload-zone ${dragActive ? 'drag-active' : ''}`}>
                    <input
                      onChange={uploadFile}
                      disabled={form.source === "0" ? true : false}
                      type="file"
                      className="hidden-input"
                      id="sourceFile"
                      name="file"
                      accept={form.source === 'sportec' ? ".zip" : ".ea5, .txt, .json, .zip, .mp4, .avi, .mov"}
                      onDragEnter={() => setDragActive(true)}
                      onDragLeave={() => setDragActive(false)}
                      onDrop={() => setDragActive(false)}
                    />
                    <div className="upload-content">
                      <i className={`fa ${form.source === 'sportec' ? 'fa-file-archive-o' : 'fa-cloud-upload'} upload-icon`}></i>
                      <div className="upload-text-main">
                        {sourceFile ? sourceFile.name : (form.source === 'sportec' ? "Drag & drop your position data (zip) here" : "Drag & drop your match video here")}
                      </div>
                      <div className="upload-text-sub">
                        {sourceFile ? "Click to change file" : (form.source === 'sportec' ? "Contact admin for more details" : "or click to browse")}
                      </div>
                      <div className="upload-meta">
                        {form.source === 'sportec'
                          ? "Supported formats: ZIP"
                          : "Supported formats: MP4, MOV • Est. processing: ~3x video duration"}
                      </div>
                    </div>
                  </div>

                  {errors.length > 0 && errors.some((val) => val.path[0] === "filename") && (
                    <div className="text-danger mt-2 text-center">
                      {errors.find(val => val.path[0] === "filename").message}
                    </div>
                  )}

                  {warningMessage && (
                    <div className={`alert ${warningColor === "green" ? "alert-success" : "alert-warning"} mt-3`}>
                      <i className={`mr-2 fa ${warningColor === "green" ? "fa-check-circle" : "fa-exclamation-circle"}`}></i>
                      {warningMessage}
                    </div>
                  )}

                  {progress > 0 && (
                    <div className="mt-3">
                      <label>Upload progress:</label>
                      <ProgressBar now={progress} label={`${progress}%`} animated striped className="saiva-progress" />
                    </div>
                  )}
                </div>
              )}

              <div className="form-group mt-4 pt-3 border-top">
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="favoriteCheck"
                    name="favorite"
                    checked={form.favorite}
                    onChange={onChange}
                  />
                  <label className="custom-control-label font-weight-bold" htmlFor="favoriteCheck">{t('Mark as Favorite')}</label>
                  <small className="form-text text-muted pl-4 mt-0">
                    Add this scenario to your favorites list for quick access.
                  </small>
                </div>
              </div>
            </div>

            <div className="row mt-3 mb-5">
              <div className="col-12 text-right">
                <Link to="/scenarios" className="btn btn-ghost mr-3 px-4">
                  {t('Cancel')}
                </Link>
                <button disabled={isSaveDisabled ? true : false} type="submit" className="btn btn-hero px-5">
                  <i className="fa fa-cloud-upload mr-2"></i> {t('Save Scenario')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddScenario;
